export default "assets/images/quote-740e10ac.svg";